import { useState } from "react";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";

export default function App() {
  const [screen, setScreen] = useState("landing"); // "landing" | "dashboard"

  return screen === "landing"
    ? <Landing onEnter={() => setScreen("dashboard")} />
    : <Dashboard onBack={() => setScreen("landing")} />;
}
